module.exports = __webpack_public_path__ + "media/components/assets/img/logo/testimonials/google-e7d8d9660474ed4a5173f2dc4e9998bf.svg";